<template>
  <footer class="footer" :class="isVind ? 'background' : 'background-portal'">
    <div v-if="showMainRow" class="row main-row">
      <div class="logo-header">
        <a href="/search-grants" :aria-label="t('navbar.logo')">
          <div :class="languageCode == 'nl' ? 'logo' : 'logo-german'"></div>
        </a>
      </div>
      <div class="footer-top-section">
        <div class="column">
          <h2 class="items-heading bold-font">{{ t("footer.sitemap") }}:</h2>
          <ul class="footer-top-links-l">
            <li>
              <a class="info-top row" :href="contactUrl" target="_blank">{{
                t("footer.contact")
              }}</a>
            </li>
            <li>
              <a class="info-top row" :href="aboutUsUrl" target="_blank">{{
                t("footer.about_us")
              }}</a>
            </li>
            <li v-if="languageCode == 'de'">
              <a class="info-top row" href="/Impressum" target="_blank">{{
                t("footer.impressum")
              }}</a>
            </li>
            <li v-if="languageCode == 'nl'">
              <a
                class="info-top row"
                href="https://ignite-group.com/nl/algemene-voorwaarden/"
                target="_blank"
                >{{ t("footer.terms_and_conditions") }}</a
              >
            </li>
            <li v-if="languageCode == 'nl'">
              <a
                class="info-top row"
                href="https://www.vindsubsidies.nl/faq-database/"
                target="_blank"
              >
                {{ t("footer.faq_database") }}
              </a>
            </li>
          </ul>
        </div>
        <div class="column">
          <h2 class="items-heading bold-font">{{ t("footer.contact") }}:</h2>
          <div class="footer-top-links-m">
            <span class="info-top">{{ contactNumber }}</span>
          </div>
          <div class="footer-top-links-m">
            <a class="info-top" :href="'mailto:' + contactMail">
              <span class="info-top">{{ contactMail }}</span>
            </a>
          </div>
        </div>
        <div class="column">
          <h2 class="items-heading bold-font">{{ t("footer.follow_us") }}:</h2>
          <ul class="row footer-top-links-r">
            <li v-if="twitterUrl">
              <a
                class="info-links"
                :aria-label="t('footer.twitter_link')"
                :href="twitterUrl"
                target="_blank"
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                "
              >
                <i class="fa-brands fa-x-twitter fa-xl social-icon"></i>
              </a>
            </li>
            <li v-if="facebookUrl">
              <a
                class="info-links"
                :aria-label="t('footer.facebook_link')"
                :href="facebookUrl"
                target="_blank"
              >
                <i class="lab la-2x la-facebook-f social-icon"></i>
              </a>
            </li>
            <li v-if="linkedinUrl">
              <a
                class="info-links"
                :aria-label="t('footer.linkedIn_link')"
                :href="linkedinUrl"
                target="_blank"
              >
                <i class="lab la-2x la-linkedin-in social-icon"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else class="portals-footer">
      <div
        v-if="customer.phoneNumber || customer.emailAddress"
        class="column portal-contact-info"
      >
        <h2 class="items-heading-portals q-mb-sm bold-font">
          {{ t("footer.contact") }}:
        </h2>

        <div v-if="customer.phoneNumber" class="flex">
          <span class="items-heading-info">{{ customer.phoneNumber }}</span>
        </div>
        <div v-if="customer.emailAddress" class="footer-top-links-m">
          <a v-bind:href="`mailto:${customer.emailAddress}`">
            <span class="items-heading-info">{{ customer.emailAddress }}</span>
          </a>
        </div>
      </div>
      <div class="column">
        <h2 v-if="showSocialMedia" class="items-heading-portals bold-font">
          {{ t("footer.follow_us") }}:
        </h2>
        <ul class="row footer-top-links-r">
          <li v-if="customer.twitterUrl">
            <a
              class="info-links"
              :aria-label="
                t('footer.twitter_link') +
                ` ${customer.customerPortalSignatureName}`
              "
              :href="customer.twitterUrl"
              target="_blank"
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <i class="fa-brands fa-x-twitter social-icon-portals"></i>
            </a>
          </li>
          <li v-if="customer.facebookUrl">
            <a
              class="info-links"
              :aria-label="
                t('footer.facebook_link') +
                ` ${customer.customerPortalSignatureName}`
              "
              :href="customer.facebookUrl"
              target="_blank"
            >
              <i class="lab la-facebook-f social-icon-portals"></i>
            </a>
          </li>
          <li v-if="customer.linkedinUrl">
            <a
              class="info-links"
              :aria-label="
                t('footer.linkedIn_link') +
                ` ${customer.customerPortalSignatureName}`
              "
              :href="customer.linkedinUrl"
              target="_blank"
            >
              <i class="lab la-linkedin-in social-icon-portals"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom-footer">
      <span v-if="isVind" class="bottom-text">
        <a
          class="no-style-link"
          :aria-label="t('footer.terms_and_conditions')"
          :href="termsAndConditionsUrl"
          target="_blank"
        >
          {{ t("footer.terms_and_conditions") }}
        </a>
        |
        <a
          class="no-style-link"
          :aria-label="t('footer.privacy_and_cookie_policy')"
          href="https://ignite-group.com/nl/cookies/?_gl=1%2a1is9sbi%2a_up%2aMQ..%2a_gs%2aMQ..&gclid=EAIaIQobChMIx_K945uyjgMVJ6ODBx0ScyTKEAAYASAAEgLdjfD_BwE"
          target="_blank"
          v-if="languageCode == 'nl'"
        >
          {{ t("footer.privacy_and_cookie_policy") }}
        </a>
        <a
          v-else
          class="no-style-link"
          :aria-label="t('footer.privacy_and_cookie_policy')"
          href="https://ignite-group.com/de/datenschutzerklaerung-fuer-das-foerderportal/"
          target="_blank"
        >
          {{ t("footer.privacy_and_cookie_policy") }}
        </a>
        |
        <a
          class="no-style-link"
          :aria-label="t('footer.disclaimer')"
          href="https://ignite-group.com/nl/disclaimer/?_gl=1%2a1is9sbi%2a_up%2aMQ..%2a_gs%2aMQ..&gclid=EAIaIQobChMIx_K945uyjgMVJ6ODBx0ScyTKEAAYASAAEgLdjfD_BwE"
          target="_blank"
        >
          {{ t("footer.disclaimer") }}
        </a>
        | © {{ currentYear }} vindsubsidies.nl |
        {{ t("footer.design_by") }}</span
      >
      <span v-else class="bottom-text">
        <a
          target="_blank"
          class="portal-terms-link"
          href="https://ignite-group.com/nl/algemene-voorwaarden/"
        >
          {{ t("footer.terms_of_use") }} &nbsp;
        </a>
        | © {{ currentYear }} vindsubsidies.nl |
        {{ t("footer.design_by") }}</span
      >
    </div>
  </footer>
</template>

<script>
import store from "../store/index.js";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import authService from "../services/auth.service";
import moment from "moment";

export default {
  setup() {
    onMounted(async () => {
      await authService.getEnvironment();
      await authService.getPortalInfo();
    });

    const route = useRoute();

    const isVind = computed(
      () => store.state.auth.env === 0 || store.state.auth.env === 40
    );
    const customer = computed(() => store.state.auth.customer);
    const showMainRow = computed(
      () => isVind.value && route.path != "/public/news-details"
    );
    const showSocialMedia = computed(
      () =>
        customer.value.twitterUrl != null ||
        customer.value.facebookUrl != null ||
        customer.value.linkedinUrl != null
    );

    const languageCode = ref(useI18n().locale.value);
    const facebookUrl = ref(
      languageCode.value == "nl"
        ? "https://www.facebook.com/ignitegroupnederland"
        : " https://www.facebook.com/Ignite.Group.Deutschland/"
    );
    const linkedinUrl = ref(
      languageCode.value == "nl"
        ? "https://www.linkedin.com/company/ignitegroupnl"
        : "https://de.linkedin.com/company/ignite-group-deutschland"
    );
    const contactNumber = ref(
      languageCode.value == "nl" ? "088 - 2020 401" : "+49 6894 99956 0"
    );
    const contactMail = ref(
      languageCode.value == "nl"
        ? "info@ignite-group.nl"
        : "info@ignite-group.de"
    );
    const twitterUrl = ref(
      languageCode.value == "nl" ? "https://x.com/IgniteGroupNL" : ""
    );
    const contactUrl = ref(
      languageCode.value == "nl"
        ? "https://ignite-group.com/nl/contact/"
        : "https://ignite-group.com/de/kontakt/"
    );
    const aboutUsUrl = ref(
      languageCode.value == "nl"
        ? "https://ignite-group.com/nl/over-ons/"
        : "https://ignite-group.com/de/ueber-uns/"
    );

    const termsAndConditionsUrl = ref(
      languageCode.value == "nl"
        ? "https://ignite-group.com/nl/algemene-voorwaarden/?_gl=1%2a1is9sbi%2a_up%2aMQ..%2a_gs%2aMQ..&gclid=EAIaIQobChMIx_K945uyjgMVJ6ODBx0ScyTKEAAYASAAEgLdjfD_BwE"
        : "https://ignite-group.com/de/agb-deutsches-foerderportal-ignite/"
    );

    const currentYear = moment().year();

    return {
      termsAndConditionsUrl,
      currentYear,
      languageCode,
      isVind,
      customer,
      linkedinUrl,
      facebookUrl,
      twitterUrl,
      contactNumber,
      contactMail,
      contactUrl,
      aboutUsUrl,
      showMainRow,
      showSocialMedia,
    };
  },
};
</script>
